import { UI } from 'common';
import React from 'react';
import { getUserType } from '../../utils/userType';

const { FeatureTile } = UI;

// Features Component
const Features = () => {
	const handleCardClick = (url: string) => () => {
		// Open help center URL in new tab
		window.open(url, '_blank', 'noopener,noreferrer');
	};

	const consumerCards = [
		{
			id: 'connect-scale',
			headline: 'Connect your scale.',
			description:
				'Connect a postage scale for accurate, instant weight imports and seamless label printing.',
			icon: 'ConnectedNetwork02',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/21040393365531-Connect-Use-a-USB-Postal-Scale'
			),
		},
		{
			id: 'schedule-package-pickups',
			headline: 'Schedule package pickups.',
			description:
				'Arrange a pickup to avoid driving, waiting in line, and missing a deadline.',
			icon: 'CalendarEvent',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/21040486749723-Schedule-a-Pickup'
			),
		},
		{
			id: 'add-apply-favorites',
			headline: 'Add and apply favorites.',
			description:
				'Create a favorite configuration to save time when you send similar items.',
			icon: 'Heart01',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/20821651459355-Creating-Using-Favorites'
			),
		},
		{
			id: 'track-mail-shipments',
			headline: 'Track mail and shipments.',
			description:
				'Follow your items from label print to delivery to ease your mind.',
			icon: 'TrackAndTrace',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/21040473261083-Track-Your-Shipments'
			),
		},
	];

	const businessCards = [
		{
			id: 'business-activity-reports',
			headline: 'Create activity and spend reports',
			description:
				'Keep your budget on track with visibility into everything you send and spend.',
			icon: 'Report',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/21289939990299-View-Download-Reports'
			),
		},
		{
			id: 'business-schedule-pickups',
			headline: 'Schedule package pickups',
			description:
				'Arrange a pickup to avoid driving, waiting in line, and missing a deadline.',
			icon: 'CalendarEvent',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/21040486749723-Schedule-a-Pickup'
			),
		},
		{
			id: 'business-add-favorites',
			headline: 'Add and apply favorites',
			description:
				'Create a favorite configuration to save time when you send similar items.',
			icon: 'Heart01',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/20821651459355-Creating-Using-Favorites'
			),
		},
		{
			id: 'business-track-mail',
			headline: 'Track mail and shipments',
			description:
				'Follow your items from label print to delivery to ease your mind.',
			icon: 'TrackAndTrace',
			onClick: handleCardClick(
				'https://help.stamps.com/hc/en-us/articles/21040473261083-Track-Your-Shipments'
			),
		},
	];

	// Get the appropriate cards based on user type
	const userType = getUserType();
	const cards = userType === 'business' ? businessCards : consumerCards;

	return (
		<div className="home-videos-and-features-cards">
			{cards.map(card => (
				<FeatureTile key={card.headline} {...card} />
			))}
		</div>
	);
};

export default Features;
